module.exports = "/images/economy-and-finance-background.png?b1ade72510c5a1c45ff2818af845f0fe";